<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" class="icon-plus-minus" :class="{'icon-plus-minus_change-state': minus}">
    <use class="svg-colorized-el" transform="translate(0 8)" xlink:href="#icon-plus-minus_fill"/>
    <use class="svg-colorized-el minus__line" transform="matrix(0 -1 1 0 8 18)" xlink:href="#icon-plus-minus_fill" />
    <defs>
      <path id="icon-plus-minus_fill" d="M0 1a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"/>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    minus: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  .icon-plus-minus_change-state {
    .minus__line {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/icons/IconPlusMinus.vue